cv.ConfirmView = Marionette.LayoutView.extend({
  id: 'modal-confirm',

  template: cv.Templates['global/modals/confirm'],

  events : {
    'click .modal-confirm' : 'confirm',
    'click .modal-deny' : 'deny'
  },

  validation: {},

  initialize: function(options){
    this.options = options;

    console.log('ConfirmView initialized');
  },

  templateHelpers: function(){
    return {
      title : _.has(this.options, 'title') ? this.options.title : 'Confirm',
      message : _.has(this.options, 'message') ? this.options.message : '',
      confirm : _.has(this.options, 'confirm') ? this.options.confirm : 'Yes',
      deny : _.has(this.options, 'deny') ? this.options.confirm : 'No'
    };
  },

  confirm: function(e){
    e.preventDefault();

    this.trigger('confirm');
    vent.trigger('modal:hide');
  },

  deny: function(e){
    e.preventDefault();

    this.trigger('deny');
    vent.trigger('modal:hide');
  }
});
